












































































import mixins from 'vue-typed-mixins'
import routeMixin from '@/router/routeMixin'
import { CommandeKitPretDTO, CommandeProduitKitPretDTO, SuiviKit_Statut, SuiviKit_Statut_ToText } from './models/CommandeKitPret'
import _ from 'lodash'
import Openable from '@/global/viewmodels/openable'
import globalMixin from '../globalMixin'
import { SendMailKit } from './models/SendMailKit'

export default mixins(routeMixin, globalMixin).extend({
    components: {
        DialogMail: () => import('../../layout/components/DialogMail.vue'),
    },
    props: {
        kits: {
            default: false,
            type: Boolean,
        },
        prets: {
            default: false,
            type: Boolean,
        },
    },
    data: function () {
        return {
            data: [] as CommandeKitPretDTO[],
            commandeKit: null as null | CommandeKitPretDTO,
            headers: [
                { text: 'Code commande', value: 'codeCommande' },
                { text: 'Client', value: 'codeClient' },
                { text: 'Date commande', value: 'dateCommande' },
                { text: 'Nombre produits', value: 'nombreProduits' },
                { text: 'Statut', value: 'statut' },
                { text: 'Utilisateur en charge', value: 'userLastTraitement' },
                { text: "", value : "actions"}
            ],
            dialog: new Openable(),
            dialogMail: new Openable(),
            mail: new SendMailKit(),
        }
    },
    methods: {
        getInfosKits() {
            this.$http
                .api(`kitspret`)
                .get()
                .then((x) => {
                    this.data = x.data
                })
                .catch((x) => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        getInfosPrets() {
            this.$http
                .api(`kitspret/prets`)
                .get()
                .then((x) => {
                    this.data = x.data
                })
                .catch((x) => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        checkDetail(commandeKit: CommandeKitPretDTO) {
            this.commandeKit = commandeKit
            this.dialog.open()
        },
        formatDate(date: string) {
            return new Date(date).toLocaleDateString('fr-FR')
        },
        formatEntreprise(codeClient: string) {
            if (!this.companiesLoaded && this.$database.companies.length == 0) this.loadCompany()

            const entreprise = _.find(this.$database.companies, (e) => codeClient.startsWith(e.code))
            if (entreprise) return `${entreprise.libelle}`

            return null
        },
        SuiviKit_Statut_ToText(statut: SuiviKit_Statut) {
            return SuiviKit_Statut_ToText(statut)
        },
        enumToColor(statut: SuiviKit_Statut) {
            switch (statut) {
                case SuiviKit_Statut.Nouveau:
                    return 'info'
                case SuiviKit_Statut.EnCours:
                    return 'warning'
                case SuiviKit_Statut.Traite:
                    return 'success'
            }
        },
        setStatutWithText(commandeKitPret: CommandeKitPretDTO, enum_: string) {
            const value = enum_ == 'Nouveau' ? SuiviKit_Statut.Nouveau : enum_ == 'EnCours' ? SuiviKit_Statut.EnCours : SuiviKit_Statut.Traite
            commandeKitPret.statut = value
            return this.save(commandeKitPret, value)
        },
        save(commandeKitPret: CommandeKitPretDTO, statut: SuiviKit_Statut) {
            this.$loader.go()
            this.$http
                .api(`kitsPret`)
                .post(commandeKitPret)
                .then((x) => {
                    this.$swal.toast.success()
                    this.getInfosKits()
                    this.loadPastilles()
                })
                .catch((x) => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        openEnvoiMail(demande: CommandeKitPretDTO) {
            // this.modalEnvoiMailDemandeReeditionFacture(demande) // OLD version

            this.mail = new SendMailKit()
            this.mail.codeCommande = demande.codeCommande 
            this.dialogMail.open()
        },
        envoyerMail(mail: SendMailKit) {
            const formData = new FormData()

            if (!mail) return

            formData.append('codeCommande', mail.codeCommande.toString())

            if (!mail.mail) {
                this.$swal.toast.error('Aucun mail renseigné.')
                return
            }
            formData.append('mail', mail.mail)

            if (!mail.corps) {
                this.$swal.toast.error('Aucun corps renseigné.')
                return
            }
            formData.append('corps', mail.corps)

            for (const file of mail.files) {
                formData.append('files', file)
            }

            this.$loader.go()

            this.$http
                .api("kitsPret/send-mail")
                .post(formData)
                .then(x => {
                    this.$swal.toast.success("Le mail a bien été envoyé.")
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        }
    },
    computed: {
        produitsDetail(): { codeProduit: string; produits: CommandeProduitKitPretDTO[] }[] {
            if (this.commandeKit) {
                return _.chain(this.commandeKit.produits)
                    .groupBy((x) => x.codeProduit)
                    .map((x, y) => {
                        return { codeProduit: y, produits: x }
                    })
                    .value()
            }
            return []
        },
    },
    mounted() {
        if (this.kits) this.getInfosKits()
        if (this.prets) this.getInfosPrets()
    },
})
